function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2.358,
  d: "M.118 24.944h49.713M.118 1.371h49.713"
});

function SvgCalculatorIcon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 27",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCA1MCAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjAuMTE4MTY0IiB5MT0iMjQuOTQ0IiB4Mj0iNDkuODMxMiIgeTI9IjI0Ljk0NCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjM1NzU3Ii8+CjxsaW5lIHgxPSIwLjExODE2NCIgeTE9IjEuMzcwNzciIHgyPSI0OS44MzEyIiB5Mj0iMS4zNzA3OCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjM1NzU3Ii8+Cjwvc3ZnPgo=";
export { SvgCalculatorIcon4 as ReactComponent };